"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _m = _interopRequireDefault(require("../styles/m-43.css"));

var _m2 = _interopRequireDefault(require("./m-43.props/m-43.defaultProps"));

var _m3 = _interopRequireDefault(require("./m-43.props/m-43.propTypes"));

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;

var VideoBlock = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(VideoBlock, _React$Component);

  function VideoBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = VideoBlock.prototype;

  _proto.getYoutubeURL = function getYoutubeURL(youtubeVideoId) {
    return "https://www.youtube.com/embed/" + youtubeVideoId + "?modestbranding=1&rel=0";
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        defaultData = _this$props.defaultData;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var youtubeVideoId = componentData.video.youtubeVideoId,
        textBlockPosition = componentData.textBlockPosition;
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "" + theme['container-fluid']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _m["default"].videoContainer + " " + _m["default"][textBlockPosition]
    }, /*#__PURE__*/_react["default"].createElement("iframe", {
      className: _m["default"].videoIframe,
      src: this.getYoutubeURL(youtubeVideoId),
      frameBorder: "0"
    })));
  };

  return VideoBlock;
}(_react["default"].Component);

exports["default"] = VideoBlock;
VideoBlock.displayName = 'VideoBlock';
VideoBlock.defaultProps = {
  data: _m2["default"],
  defaultData: _m2["default"],
  theme: {}
};